import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { isAuthenticated } from "./api/auth.api";

import MainLayout from "./layout/MainLayout";
import Login      from "./pages/Login";
import Dashboard  from "./pages/Dashboard";
import Gtd        from "./pages/Gtd";
import Sprint     from "./pages/Sprint";
import Developers from "./pages/Developers";
import DevKanban    from "./pages/DevKanban";
import Retrabalhos  from "./pages/developers/Retrabalhos";
import Velocidade   from "./pages/developers/Velocidade";
import Produtividade from "./pages/developers/Produtividade";
import Tempos        from "./pages/developers/Tempos";
import Burndown   from "./pages/Burndown";
import Programacao    from "./pages/Programacao";
import Gargalos       from "./pages/programacao/Gargalos";
import Transferencias from "./pages/programacao/Transferencias";
import Emergencia     from "./pages/programacao/Emergencia";
import Setup          from "./pages/Setup";
import Acompanhamento        from "./pages/projetos/Acompanhamento";
import ProjetosDashboard    from "./pages/projetos/Dashboard";
import TarefasSetup          from "./pages/tarefas/Setup";
import TarefasAcompanhamento from "./pages/tarefas/Acompanhamento";
import TarefasPrazos         from "./pages/tarefas/Prazos";
import TarefasResponsaveis   from "./pages/tarefas/Responsaveis";
import DashboardExecutivo    from "./pages/tarefas/DashboardExecutivo";
import TarefasCalendario    from "./pages/tarefas/Calendario";
import SprintHistorico      from "./pages/SprintHistorico";
import SprintRetrospectiva  from "./pages/SprintRetrospectiva";
import SprintEstimativas    from "./pages/SprintEstimativas";
import SprintComparar       from "./pages/SprintComparar";
import SprintSaude          from "./pages/SprintSaude";
import CicloVida            from "./pages/tickets/CicloVida";
import Parametros           from "./pages/Parametros";

function PrivateRoute({ children }) {
  return isAuthenticated() ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>

        <Route path="/login" element={<Login />} />

        <Route
          path="/"
          element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="/gtd"                    element={<Gtd />} />
          <Route path="/sprint"                element={<Sprint />} />
          <Route path="/burndown"              element={<Burndown />} />
          <Route path="/sprint/historico"        element={<SprintHistorico />} />
          <Route path="/sprint/retrospectiva"   element={<SprintRetrospectiva />} />
          <Route path="/sprint/estimativas"     element={<SprintEstimativas />} />
          <Route path="/sprint/comparar"        element={<SprintComparar />} />
          <Route path="/sprint/saude"           element={<SprintSaude />} />
          <Route path="/parametros"             element={<Parametros />} />
          <Route path="/developers/resumo"      element={<Developers />} />
          <Route path="/developers/kanban"       element={<DevKanban />} />
          <Route path="/developers/retrabalhos" element={<Retrabalhos />} />
          <Route path="/developers/velocidade"  element={<Velocidade />} />
          <Route path="/developers/produtividade" element={<Produtividade />} />
          <Route path="/developers/tempos"      element={<Tempos />} />
          <Route path="/developers"             element={<Navigate to="/developers/resumo" replace />} />
          <Route path="/programacao/setup"          element={<Setup />} />
          <Route path="/programacao/kanban"         element={<Programacao />} />
          <Route path="/programacao/gargalos"       element={<Gargalos />} />
          <Route path="/programacao/transferencias" element={<Transferencias />} />
          <Route path="/programacao/emergencia"     element={<Emergencia />} />
          <Route path="/programacao"                element={<Navigate to="/programacao/kanban" replace />} />
          <Route path="/projetos/dashboard"         element={<ProjetosDashboard />} />
          <Route path="/projetos/acompanhamento"    element={<Acompanhamento />} />
          <Route path="/projetos"                   element={<Navigate to="/projetos/dashboard" replace />} />
          <Route path="/tarefas/setup"              element={<TarefasSetup />} />
          <Route path="/tarefas/acompanhamento"     element={<TarefasAcompanhamento />} />
          <Route path="/tarefas/prazos"             element={<TarefasPrazos />} />
          <Route path="/tarefas/calendario"         element={<TarefasCalendario />} />
          <Route path="/tarefas/responsaveis"       element={<TarefasResponsaveis />} />
          <Route path="/tarefas/dashboard"          element={<DashboardExecutivo />} />
          <Route path="/tarefas"                    element={<Navigate to="/tarefas/setup" replace />} />
          <Route path="/tickets/ciclo"              element={<CicloVida />} />
        </Route>

        {/* Qualquer rota desconhecida redireciona para home */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
